import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageTransition } from "@/components/PageTransition";
import { IPhoneComparisonStandalone } from "@/components/IPhoneComparisonStandalone";
import { BottomNavigation } from "@/components/BottomNavigation";
import { MenuDrawer } from "@/components/MenuDrawer";
import { useTheme } from "@/hooks/useTheme";

const ConfrontaIPhone = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const { preference } = useTheme();

  // Determine if dark mode is active for bottom nav variant
  const isDark = preference === "dark" || (preference === "auto" && (new Date().getHours() < 6 || new Date().getHours() >= 18));

  return (
    <PageTransition>
      <IPhoneComparisonStandalone onBack={() => navigate(-1)} />
      <MenuDrawer open={menuOpen} onOpenChange={setMenuOpen} />
      <BottomNavigation onMenuClick={() => setMenuOpen(true)} variant={isDark ? "dark" : "light"} />
    </PageTransition>
  );
};

export default ConfrontaIPhone;
